import React from 'react'

export const IconDownload: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16 16">
      <title>download</title>
      <path d="M8 10l2.667-2.667h-2v-4h-1.333v4h-2z" />
      <path d="M12 7.333v4h-8v-4h-1.333v4.667c0 0.369 0.298 0.667 0.667 0.667h9.333c0.369 0 0.667-0.298 0.667-0.667v-4.667h-1.333z" />
    </svg>
  )
}
